import React from "react";
import { UserContext } from "../../../context/UserContext";

export const useToast = () => {
  const { toastList, setToastList } = React.useContext(UserContext);
  const showToast = ({ type = "success", message }) => {
    let toast = {
      type: type,
      text: message,
      autoClose: true,
    };
    setToastList([...toastList, toast]);
  };

  return { showToast };
};
